import styled from "@emotion/styled";

export const StyledIcon = styled.i`
  font-size: 8px;
  padding-bottom: 8px;
`;

export const RightArrowIcon = () => (
  <StyledIcon className="fa-kit fa-btn-arrow"></StyledIcon>
);
